import { createTheme } from '@mui/material/styles';

import layout from './layout';
import palette from './palette';
import typography from './typography';

const baseTheme = createTheme({
  palette,
  typography,
  layout,
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1440,
    },
  },
});

export default baseTheme;
